export default __webpack_public_path__ + "static/media/010_home.hevc.f1e5b11c.mp4";